import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchDataEntriesApi,
  createBulkDataEntriesApi,
  updateDataEntryApi,
  deleteDataEntryApi,
} from "./dataEntriesApi";

export const fetchDataEntries = createAsyncThunk(
  "dataEntries/fetchAll",
  async ({ year, month, dataType }, { rejectWithValue }) => {
    try {
      const data = await fetchDataEntriesApi(year, month, dataType);
      return data;
    } catch (error) {
      if (error.response?.data) return rejectWithValue(error.response.data.message || "Kayıtlar alınamadı.");
      return rejectWithValue("Bağlantı hatası");
    }
  }
);

export const saveBulkDataEntries = createAsyncThunk(
  "dataEntries/saveBulk",
  async (items, { rejectWithValue }) => {
    try {
      const data = await createBulkDataEntriesApi(items);
      return data;
    } catch (error) {
      if (error.response?.data) return rejectWithValue(error.response.data.message || "Kaydedilemedi.");
      return rejectWithValue("Bağlantı hatası");
    }
  }
);

export const updateDataEntry = createAsyncThunk(
  "dataEntries/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await updateDataEntryApi(id, data);
      return { id, data, res };
    } catch (error) {
      if (error.response?.data) return rejectWithValue(error.response.data.message || "Güncellenemedi.");
      return rejectWithValue("Bağlantı hatası");
    }
  }
);

export const deleteDataEntry = createAsyncThunk(
  "dataEntries/delete",
  async (id, { rejectWithValue }) => {
    try {
      await deleteDataEntryApi(id);
      return id;
    } catch (error) {
      if (error.response?.data) return rejectWithValue(error.response.data.message || "Silinemedi.");
      return rejectWithValue("Bağlantı hatası");
    }
  }
);
